import React from 'react';
import styled from 'styled-components';
import CloseIcon from '../../../assets/icons/close.svg';
import Checkbox from 'monday-ui-react-core/dist/Checkbox';
import { useColumnOrder } from '../../../hooks/useColumnOrder';
import ReorderableList from './ReorderableList';
import { useTranslation } from 'react-i18next';

const ControllerSettingsContainer = styled.div`
  width: 350;
  border-radius: 8px;
  background: var(--light-primary-background-color, #fff);
  padding: 18px 14px 18px 14px;
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);

  .text {
    color: var(--light-primary-text-color, #323338);
    font-family: Roboto;
    font-size: 18px;
    font-weight: bold;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
      cursor: pointer;
    }
  }

  .content {
    margin: 20px 0 20px 0;
    display: flex;
    gap: 30px;
    @media only screen and (max-width: 768px) {
      flex-direction: column;
    }
  }
`;

const SignatureOrder = ({ closeModal }) => {
  const { signersSettings, handleCheckboxClick, handleDragOrder } =
    useColumnOrder();
  const { t } = useTranslation();

  return (
    <ControllerSettingsContainer>
      <div className="header">
        <div className="text">Select Column, color & order</div>
        <img
          className="icon"
          src={CloseIcon}
          alt="close"
          onClick={() => closeModal(false)}
        />
      </div>

      <div className="body">
        <Checkbox
          label={t('Signing Order Required')}
          checked={signersSettings.isSigningOrderRequired}
          onChange={handleCheckboxClick}
        />
        <div className="content">
          {signersSettings.isSigningOrderRequired ? (
            <ReorderableList
              items={signersSettings.signers}
              handleDragOrder={handleDragOrder}
            />
          ) : null}
        </div>
      </div>
    </ControllerSettingsContainer>
  );
};

export default SignatureOrder;
